import { render } from "./burger_menu.vue?vue&type=template&id=dae6185e&scoped=true"
import script from "./burger_menu.vue?vue&type=script&lang=js"
export * from "./burger_menu.vue?vue&type=script&lang=js"

import "./burger_menu.vue?vue&type=style&index=0&id=dae6185e&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dae6185e"]])

export default __exports__